import { JSX } from 'react'

import logo from '../../assets/img/doctor.svg'

export const DoctorIcon = (): JSX.Element => {
  return <img src={logo} height="20" alt="doctor" id="doctorIcon" />
}
